import Service from '../Service'
import {http} from '../config'

export default class PlanoContaService extends Service{

    constructor(){
        super('planoconta');
    }

    ListarByTipo(tipo, include){

        let filtro = '';

        if (tipo) {
            filtro += `?$filter=tipo eq '${tipo}' and id gt 0`;
        }

        if (filtro) { filtro += ' and '; }
            filtro+= `itens/any(o: o/Ativo eq true)`;

        return http.get(`${this._nomeControle}${filtro}`, this.GetHeader(include));
    }

    GetPlanoContaItem(id, itemId){
        return http.get(`${this._nomeControle}/${id}/item/${itemId}`);
    }

    PostPlanoContaItem(id, item){
        return http.post(`${this._nomeControle}/${id}/item`, item);
    }

    PutPlanoContaItem(id, itemId, item){
        return http.put(`${this._nomeControle}/${id}/item/${itemId}`, item);
    }

    DeletePlanoContaItem(id, itemId){
        return http.delete(`${this._nomeControle}/${id}/item/${itemId}`);
    }

}